import { render, staticRenderFns } from "./commonClassRankList.vue?vue&type=template&id=432f354c&scoped=true"
import script from "./commonClassRankList.vue?vue&type=script&lang=js"
export * from "./commonClassRankList.vue?vue&type=script&lang=js"
import style0 from "./commonClassRankList.vue?vue&type=style&index=0&id=432f354c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432f354c",
  null
  
)

export default component.exports